export default __webpack_public_path__ + "images/9_thumbnail.jpg";